"use strict";function clamp(min,value,max){return value<min?min:value>max?max:value}export default clamp;